import { Controls, Player } from '@lottiefiles/react-lottie-player'
import React from 'react'
import Layout from '../../layout/Layout'

const NotFound = () => {
  return (
    <Layout>
      <div className='flex items-center justify-center h-full'>
        <Player src={process.env.PUBLIC_URL + "/assets/animation/error-404.json"} background="rgba(0, 0, 0, 0)" speed="1" loop autoplay style={{ height: 600 }}>
          <Controls visible={false} />
        </Player>
      </div>
    </Layout>
  )
}

export default NotFound